import React from 'react';
import ReactDOM from 'react-dom';
import './_styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import axios from "axios";

import { Provider } from 'react-redux'
import store from './store'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_BASE_PATH

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
